"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FARM_VERSION_TO_PROGRAMID = exports.FARM_PROGRAMID_TO_VERSION = exports.FARM_PROGRAM_ID_V5 = exports._FARM_PROGRAM_ID_V5 = exports.FARM_PROGRAM_ID_V3 = exports._FARM_PROGRAM_ID_V3 = void 0;
const web3_js_1 = require("@solana/web3.js");
/* ================= program public keys ================= */
exports._FARM_PROGRAM_ID_V3 = "EhhTKczWMGQt46ynNeRX1WfeagwwJd7ufHvCDjRxjo5Q";
exports.FARM_PROGRAM_ID_V3 = new web3_js_1.PublicKey(exports._FARM_PROGRAM_ID_V3);
exports._FARM_PROGRAM_ID_V5 = "9KEPoZmtHUrBbhWN1v1KWLMkkvwY6WLtAVUCPRtRjP4z";
exports.FARM_PROGRAM_ID_V5 = new web3_js_1.PublicKey(exports._FARM_PROGRAM_ID_V5);
// farm program id string => farm version
exports.FARM_PROGRAMID_TO_VERSION = {
    [exports._FARM_PROGRAM_ID_V3]: 3,
    [exports._FARM_PROGRAM_ID_V5]: 5,
};
// farm version => farm program id
exports.FARM_VERSION_TO_PROGRAMID = {
    3: exports.FARM_PROGRAM_ID_V3,
    5: exports.FARM_PROGRAM_ID_V5,
};
//# sourceMappingURL=id.js.map